import type { PaletteKey } from '../palette';

/**
 * A sprite authored as code: rows of characters, each char mapped to a palette key.
 * '.' (or ' ') is always transparent. Human-made Aseprite exports can later be loaded
 * through the same `SpriteDef` shape (see rasterize.ts).
 */
export interface SpriteDef {
  id: string;
  w: number;
  h: number;
  /** char → palette key. '.' and ' ' are reserved for transparency. */
  colors: Record<string, PaletteKey>;
  /** One or more frames; each frame is `h` strings of length `w`. */
  frames: string[][];
}

export function defineSprite(def: {
  id: string;
  colors: Record<string, PaletteKey>;
  frames: string[][];
}): SpriteDef {
  const first = def.frames[0];
  if (!first || first.length === 0) throw new Error(`sprite ${def.id}: no frames`);
  const h = first.length;
  const w = first[0]!.length;
  return { id: def.id, w, h, colors: def.colors, frames: def.frames };
}

/** Convenience for single-frame sprites. */
export function sprite(id: string, colors: Record<string, PaletteKey>, rows: string[]): SpriteDef {
  return defineSprite({ id, colors, frames: [rows] });
}
